var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIconColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8115 2.43457C11.5721 1.67416 12.8049 1.67408 13.5654 2.43457C14.3259 3.19506 14.3258 4.42794 13.5654 5.18848L5.85352 12.9004C5.78625 12.9677 5.70166 13.016 5.60938 13.0391L2.92676 13.709C2.74796 13.7536 2.55902 13.7016 2.42871 13.5713C2.2984 13.441 2.2464 13.252 2.29102 13.0732L2.96094 10.3906L2.9834 10.3232C3.00971 10.2574 3.04911 10.197 3.09961 10.1465L10.8115 2.43457Z",
    stroke: "currentColor",
    strokeWidth: 1.04974,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6167 3.82373L12.0595 6.26644",
    stroke: "currentColor",
    strokeWidth: 1.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.43213 9.93549L5.87495 12.3782",
    stroke: "currentColor",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconColor);
export default __webpack_public_path__ + "static/media/edit-icon-color.d3ae2e941caef16a7c05e36bb0d7a99a.svg";
export { ForwardRef as ReactComponent };